import { createSelector } from 'reselect';
import { signInCheck } from '../../components/common/CheckUserStatus';
import { getProductProps, extractVariantsFromProduct, getSizeName } from '../utils/productUtils';
import { getLuxeFlags, getFeatureFlags } from './featureFlagsSelector';
import { getCurrentStore } from './metaData';
import properties from '../../modules/ajio-util/properties';

const getWishlist = (state: import('../types/rootState').RootState): any => state.wishlist;

const getSignInEmptyWishlistData = luxe => {
  return {
    isLogin: true,
    subHeader: 'Hang your wishes where you can make them come true.',
    image: [
      `${properties.getProperty('imageBaseUrl')}/static/img/${
        luxe ? 'luxe-wishlist.svg' : 'emptyWishlist.svg'
      }`
    ],
  };
};

const getWishlistData = createSelector(getWishlist, wishlist => wishlist?.wishlistData || []);

const getWishlistProducts = createSelector(getWishlistData, wishlistData =>
  getProductProps(wishlistData)
);

const getWishlistPriceRevealData = createSelector(
  getWishlist,
  getFeatureFlags,
  (wishlist, flags) => {
    const { saleStartTime, saleEndTime } = wishlist?.wishlistPriceRevealData || {};
    if (
      flags.priceRevealLUXEFlag &&
      flags.priceRevealV2MobileFeatureFlag &&
      flags.priceRevealMobileData?.priceRevealWISHLISTFlag === 'ON' &&
      saleStartTime &&
      saleEndTime
    )
      return {
        saleStartTime,
        saleEndTime,
        isPriceReveal: true
      };
    return false;
  }
);

const getAnonymousEmptyWishlistData = luxe => ({
  isLogin: false,
  buttonLabel: 'Login/ Join',
  subHeader: `Sign in to ${luxe ? 'save' : 'link'} products to your ${
    luxe ? 'wishlist' : 'account'
  } or view products already in your wishlist.`,
  image: [
    `${properties.getProperty('imageBaseUrl')}/static/img/${
      luxe ? 'luxe-wishlist.svg' : 'emptyWishlist.svg'
    }`
  ],
  redirectUrl: '/login?referrer=/wishlist'
});

const getEmptyWishlistData = createSelector(
  getLuxeFlags,
  getCurrentStore,
  getWishlist,
  (luxeFlags, storeName) => {
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && storeName === 'luxe';
    const EmptyWishlistData = signInCheck().length
      ? getSignInEmptyWishlistData(luxe)
      : getAnonymousEmptyWishlistData(luxe);

    return {
      header: 'Your wishlist is empty',
      ...EmptyWishlistData
    };
  }
);

export { getEmptyWishlistData, getWishlistProducts, getWishlistData, getWishlistPriceRevealData };
